Ext.define('SA.AcsTable.CellDelegate', {
    statics: {
        createCellDelegate({dataMap, topHeader, leftHeader, body}) {
            var cornerCellContentSize = {width: 0, height: 0},
                leftHeaderSizeMetricsElContainer = document.createElement('div'),
                leftHeaderSizeMetricsEl = document.createElement('div'),
                locationRenderer = new SA.view.LocationRenderer({svgIconCls: 'sa-edit-location-label-icon'}),
                cellClasses = {
                    topHeader: topHeader.cellCls,
                    leftHeader: leftHeader.cellCls,
                    body: body.cellCls
                },
                cellContentSizes = {
                    corner: cornerCellContentSize,
                    topHeader: topHeader.cellContentSize,
                    leftHeader: leftHeader.cellContentSize,
                    body: body.cellContentSize
                };

            leftHeaderSizeMetricsEl.classList.add(leftHeader.cellCls);
            leftHeaderSizeMetricsElContainer.appendChild(leftHeaderSizeMetricsEl);
            leftHeaderSizeMetricsElContainer.classList.add('sa-acs-left-header-size-metrics-el-container');
            SA.HiddenDom.attach(leftHeaderSizeMetricsElContainer);

            return new SA.AcsTable.CellDelegate({dataMap, cellClasses, cellContentSizes, locationRenderer, leftHeaderSizeMetricsEl});
        }
    },

    constructor({dataMap, cellClasses, cellContentSizes, locationRenderer, leftHeaderSizeMetricsEl}) {
        this.dataMap = dataMap;
        this.cellClasses = cellClasses;
        this.cellContentSizes = cellContentSizes;
        this.locationRenderer = locationRenderer;
        this.leftHeaderSizeMetricsEl = leftHeaderSizeMetricsEl;
    },

    getCellContentSize({rowId, colId}) {
        var isTopHeaderRow = rowId === TABLE_HEADER_TRACK_IDS.TOP_HEADER_ROW,
            isLeftHeaderCol = colId === TABLE_HEADER_TRACK_IDS.LEFT_HEADER_COL;

        if (isTopHeaderRow && isLeftHeaderCol) {
            return this.cellContentSizes.corner;
        }
        else if (isTopHeaderRow) {
            return this.cellContentSizes.topHeader;
        }
        else if (isLeftHeaderCol) {
            let content = this.getLeftHeaderCellContent({rowId});

            this.leftHeaderSizeMetricsEl.textContent = content.text;
            this.leftHeaderSizeMetricsEl.style.paddingLeft = 15 + (content.indent * 15) + 'px';

            return {
                width: this.leftHeaderSizeMetricsEl.clientWidth,
                height: this.cellContentSizes.leftHeader.height
            };
        }

        return this.cellContentSizes.body;
    },

    getLeftHeaderCellContent({rowId}) {
        let attribute = SA.data.AttributesCache.getModel(rowId),
            indent = attribute.getIndent(),
            text = attribute.getName().split(' | ').at(-1);

        return {indent, text};
    },

    initCell({sectionId, contentEl}) {
        contentEl.classList.add(this.cellClasses[sectionId]);

        if (sectionId === 'body') {
            let spinnerEl = document.createElement('div'),
                nonPercentEl = document.createElement('div'),
                percentEl = document.createElement('div');

            spinnerEl.classList.add('sa-acs-table-body-cell-spinner');
            nonPercentEl.classList.add('sa-acs-table-body-cell-non-percent-content');
            percentEl.classList.add('sa-acs-table-body-cell-percent-content');

            nonPercentEl.style.display = 'none';
            percentEl.style.display = 'none';

            contentEl.append(spinnerEl, nonPercentEl, percentEl);
        }
    },

    renderCell({sectionId, trackContentSizes, rowId, colId, dragColId, contentEl}) {
        if (sectionId === 'topHeader') {
            let location = SA.data.LocationsCache.getModel(colId),
                html = this.locationRenderer.renderLocation(location);

            contentEl.classList.toggle('sa-acs-table-top-header-cell-drag', colId === dragColId);
            contentEl.innerHTML = html;
        }
        else if (sectionId === 'leftHeader') {
            let content = this.getLeftHeaderCellContent({rowId}),
                width = trackContentSizes.getColWidth({colId: TABLE_HEADER_TRACK_IDS.LEFT_HEADER_COL});

            contentEl.textContent = content.text;
            contentEl.style.width = width + 'px';
            contentEl.style.paddingLeft = 15 + (content.indent * 15) + 'px';
        }
        else {
            let locationStringId = colId,
                nonPercentAttributeId = rowId,
                spinnerEl = contentEl.children[0],
                nonPercentEl = contentEl.children[1],
                percentEl = contentEl.children[2],
                attributeLoaded = attributeId => this.dataMap.loadedAttributes[attributeId],
                locationLoaded = locationStringId => this.dataMap.loadedLocations[locationStringId],
                getValue = attributeId => this.dataMap.getData()[locationStringId][attributeId];

            if (locationLoaded(locationStringId) && attributeLoaded(nonPercentAttributeId)) {
                let nonPercentValue = getValue(nonPercentAttributeId),
                    formattedNonPercentValue = SA.data.AttributesCache.getModel(nonPercentAttributeId).formatValue(nonPercentValue),
                    percentCounterpartAttributeId = getCounterpartPercentAttributeId(nonPercentAttributeId);

                nonPercentEl.textContent = formattedNonPercentValue;

                spinnerEl.style.display = 'none';
                nonPercentEl.style.display = 'flex';
                percentEl.style.display = 'flex';

                if (attributeLoaded(percentCounterpartAttributeId)) {
                    let percentAttribute = SA.data.AttributesCache.getModel(percentCounterpartAttributeId),
                        percentValue = getValue(percentCounterpartAttributeId),
                        formattedPercentValue = percentAttribute.formatValue(percentValue);

                    percentEl.textContent = formattedPercentValue;
                }
                else {
                    percentEl.textContent = '';
                }
            }
            else {
                spinnerEl.style.display = 'flex';
                nonPercentEl.style.display = 'none';
                percentEl.style.display = 'none';
            }

            contentEl.classList.toggle('sa-acs-table-body-cell-drag', colId === dragColId);
        }

        function getCounterpartPercentAttributeId(attributeId) {
            var idCmps = attributeId.split('->'),
                allButLastCmps = idCmps.slice(0, -1),
                lastCmp = idCmps.at(-1);

            return allButLastCmps.join('->') + '_pct->' + lastCmp;
        }
    }
});